import { useConsole } from "contexts/Console"
import TextImageHorizontal from "./TextImageHorizontal"

export default function TextImageHorizontalPadding(props) {
  const console = useConsole()

  console.log("TestimoneeTextImageHorizontalPadding(%o)", props)

  return <TextImageHorizontal {...props} padding />
}
